import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CbTextWithImage = _resolveComponent("CbTextWithImage")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createBlock(_component_GenericFormWrapper, {
    pageUI: _ctx.pageUI,
    "submit-data": _ctx.submitData,
    "pinned-footer": ""
  }, {
    content: _withCtx(({ errors }) => [
      _createVNode(_component_CbTextWithImage, {
        ref: "cbStructure",
        "cb-id": _ctx.contentPage.cp?.overview_cb_id ?? undefined,
        "cb-type": _ctx.contentBlockOverviewType,
        errors: errors,
        "content-toolbar": "undo redo | bold italic underline strikethrough | superscript subscript | removeformat",
        "editor-options": {
          forced_root_block: false,
          newline_behavior: 'linebreak',
          valid_elements: 'br,span[class],s,sup,sub',
        },
        "is-advanced-options-available": false,
        onExceptions: _ctx.setExceptions,
        onHasUnsavedChanges: _ctx.onFormDataChanged
      }, null, 8, ["cb-id", "cb-type", "errors", "onExceptions", "onHasUnsavedChanges"])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_base_offcanvas_button_close, { class: "btn btn-light" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["pageUI", "submit-data"]))
}